import { ItemReorderEventDetail } from "@ionic/core"
import { IonButton, IonButtons, IonContent, IonItem, IonLabel, IonList, IonModal, IonReorder, IonReorderGroup, IonToolbar } from "@ionic/react"
import React from "react"
import { useState } from "react"
import { editProduct } from "../ServerProvider"

declare global {
    interface Array<T>  {
        move(from: number, to: number): void;
    }
}

// eslint-disable-next-line
Array.prototype.move = function (from: number, to: number) {
    this.splice(to, 0, this.splice(from, 1)[0]);
};

const Reorder: React.FC<{products: any[]}> = (props) => {
    const [modalOpen, setModalOpen] = useState(false)

    for (let i = 0; i < props.products.length; i++) {
        if (Object.keys(props.products[i]).indexOf("index") < 0) {
            editProduct(props.products[i].sku, {index: i})
        }
    }

    const doReorder = (event: CustomEvent<ItemReorderEventDetail>) => {
        const currentProduct = props.products[event.detail.from]
        const replacedProduct = props.products[event.detail.to]
        props.products.move(event.detail.from, event.detail.to)
        editProduct(currentProduct.sku, {index: event.detail.to})
        editProduct(replacedProduct.sku, {index: event.detail.to + 1})
        event.detail.complete();
    }

    return <>
        <IonButton onClick={() => setModalOpen(true)}>Edit Product Placement</IonButton>
        <IonModal isOpen={modalOpen}>
            <IonToolbar>
                <IonButtons slot="primary">
                    <IonButton onClick={() => setModalOpen(false)}>Done</IonButton>
                </IonButtons>
            </IonToolbar>

            <IonContent>
                <IonList>
                    <IonReorderGroup disabled={false} onIonItemReorder={doReorder}>
                        {props.products.map((product, i) => <IonItem key={i}>
                            <IonLabel>{product.name} {product.index}</IonLabel>
                            <IonReorder slot="end" />
                        </IonItem>)}
                    </IonReorderGroup>
                </IonList>
            </IonContent>
        </IonModal>
    </>
}

export default Reorder